<script lang="ts">
    import { HAIR_STROKE_OPTIONS } from '../types/hair-stroke'

    export let data: Record<string, any>
</script>

<div class="hair-scale">
    {#each HAIR_STROKE_OPTIONS as option (option.key)}
        <div class="hair-row" class:selected={option.key === 'medio'}>
            <span class="hair-label">{option.label}</span>
            <span class="hair-desc">{option.description}</span>
        </div>
    {/each}
</div>

<style>
    .hair-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .hair-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
    }
    .hair-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .hair-label {
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .hair-row.selected .hair-label {
        color: #1f2937;
    }
    .hair-desc {
        flex: 2;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .hair-row.selected .hair-desc {
        color: #1f2937;
    }
</style>
